import { logoutUser } from '../api';
import { getSessionId, clearSession } from './authStorage';
import { getHostUri } from './authHelpers';
import { createLogger } from '../utils/logging';

const logger = createLogger('SignOut');

export async function performSignOut(): Promise<void> {
  const redirectUri = getHostUri();
  const sessionId = getSessionId();

  clearSession();

  if (!sessionId) {
    window.location.href = redirectUri;
    return;
  }

  try {
    // Prevent double sign-out
    if (!sessionStorage.getItem('logout')) {
      sessionStorage.setItem('logout', 'true');
      await logoutUser();
    }
  } catch (error) {
    logger.error('Sign Out Failed', 'Error clearing server session', { error });
  }

  // Redirect home; server-side session is cleared by backend
  window.location.href = redirectUri;
}
